var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.586 6.914L15.172 5.5H8.828L7.414 6.914L6.828 7.5H6H5C4.449 7.5 4 7.949 4 8.5V17.5C4 18.051 4.449 18.5 5 18.5H19C19.551 18.5 20 18.051 20 17.5V8.5C20 7.949 19.551 7.5 19 7.5H18H17.172L16.586 6.914ZM8 3.5H16L18 5.5H19C20.657 5.5 22 6.843 22 8.5V17.5C22 19.157 20.657 20.5 19 20.5H5C3.343 20.5 2 19.157 2 17.5V8.5C2 6.843 3.343 5.5 5 5.5H6L8 3.5ZM14 12.5C14 11.397 13.103 10.5 12 10.5C10.897 10.5 10 11.397 10 12.5C10 13.603 10.897 14.5 12 14.5C13.103 14.5 14 13.603 14 12.5ZM8 12.5C8 10.291 9.791 8.5 12 8.5C14.209 8.5 16 10.291 16 12.5C16 14.709 14.209 16.5 12 16.5C9.791 16.5 8 14.709 8 12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraM);
export default __webpack_public_path__ + "static/media/camera-M.fb3df06091e4da8a4aa80d33957f629f.svg";
export { ForwardRef as ReactComponent };